import { render, staticRenderFns } from "./RealtimeCallDetailsTable.vue?vue&type=template&id=2dc7e82d&scoped=true"
import script from "./RealtimeCallDetailsTable.vue?vue&type=script&lang=js"
export * from "./RealtimeCallDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./RealtimeCallDetailsTable.vue?vue&type=style&index=0&id=2dc7e82d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc7e82d",
  null
  
)

export default component.exports